import {ViewElementInterface} from './ViewElement'

interface ViewBlockInterface {
  id: string;
  name: string;
  elements: ViewElementInterface[];
  blockId: string;
}

class ViewBlock {
  constructor(
    public id: string,
    public name: string,
    public elements: ViewElementInterface[],
    public blockId: string,
  ) {
    this.id = id;
    this.name = name;
    this.elements = elements;
    this.blockId = blockId;
  }
}

export {
  ViewBlock
}

export type {
  ViewBlockInterface
}
